import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Output,
  Renderer2,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'side-modal',
  styleUrls: ['./side-modal.component.scss'],
  templateUrl: './side-modal.component.html',
})
export class SideModalComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {}

  @Input()
  title: string;

  @Input()
  sideModalBorder: boolean = true;

  @Input()
  width: string | null = null;

  @Input()
  modalScrim: boolean = true;

  @Output()
  readonly close = new EventEmitter();

  slideInitOpen: boolean = true;

  @HostBinding('class.modal-scrim')
  get hasModalScrim() {
    return this.modalScrim;
  }

  // not the same as outsideClick directive, this includes nav bar
  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: Element): void {
    if (this.slideInitOpen) {
      this.slideInitOpen = false;
      return;
    }

    const modalElement =
      this.elementRef.nativeElement.querySelector('.content');

    const baseElement = this.elementRef.nativeElement.parentElement;

    if (
      baseElement &&
      baseElement.contains(target) &&
      !modalElement.contains(target)
    ) {
      this.closeWithSlideOut();
    }
  }

  closeWithSlideOut(): void {
    const modalElement =
      this.elementRef.nativeElement.querySelector('.content');
    this.renderer.removeClass(modalElement, 'slide-in');
    this.renderer.addClass(modalElement, 'slide-out');

    setTimeout(() => {
      this.close.emit();
    }, 500);
  }
}
